module.exports = __webpack_public_path__ + "img/photo5.5f36bc6d.png";